import { useRef, useCallback } from 'react';

type Task = () => Promise<void>;

export const usePendingTask = () => {
  const isTaskRunning = useRef(false);
  const pendingTaskRef = useRef<Task | null>(null);

  return useCallback(async (task: Task) => {
    pendingTaskRef.current = task;

    if (isTaskRunning.current) return;

    isTaskRunning.current = true;

    const runTask = async (): Promise<void> => {
      const current = pendingTaskRef.current;
      if (!current) {
        isTaskRunning.current = false;
        return;
      }

      pendingTaskRef.current = null;
      await current();
      runTask();
    };

    runTask();
  }, []);
};
